import "./App.css";
import Contactme from "./Components/ContactMe/Contactme";
import Footer from "./Components/Footer/Footer";
import Home from "./Components/Home/Home";
import Navbar from "./Components/Navbar/Navbar";
import Projects from "./Components/Projects/Projects";
import Skill from "./Components/Skill/Skill";

function App() {
  return (
    <>
      <div className="app-background" />
      <div className="main-container">
        <Navbar />
        <Home />
        <Skill />
        <Projects />
        <Contactme />
        <Footer />
      </div>
    </>
  );
}

export default App;
